import { override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import ModalManagerState from 'flarum/common/states/ModalManagerState';
import { getOidcLoginUrl, redirectToOidcLogin } from './redirect';
function isLogInModalClass(ModalClass) {
  var _ModalClass$prototype;
  if (!(ModalClass != null && (_ModalClass$prototype = ModalClass.prototype) != null && _ModalClass$prototype.className)) {
    return false;
  }
  const className = typeof ModalClass.prototype.className === 'function' ? ModalClass.prototype.className.call({
    attrs: {}
  }) : '';
  return String(className).includes('LogInModal');
}

/**
 * Redirect guests before Flarum opens LogInModal (reply placeholder, controls, etc.).
 */
export default function interceptAuthPrompts() {
  if (!getOidcLoginUrl()) {
    return;
  }
  override(DiscussionControls, 'replyAction', async function (original, goToLast, forceRefresh) {
    if (!app.session.user) {
      redirectToOidcLogin();
      return Promise.reject();
    }
    return original(goToLast, forceRefresh);
  });
  override(ModalManagerState.prototype, 'show', async function (original, componentClass, attrs, stackModal) {
    if (!getOidcLoginUrl() || typeof componentClass !== 'function') {
      return original(componentClass, attrs, stackModal);
    }
    const isAsyncLoader = !(componentClass.prototype instanceof Modal);
    if (isAsyncLoader) {
      const loaded = await componentClass();
      const resolvedModal = loaded.default;
      if (isLogInModalClass(resolvedModal)) {
        redirectToOidcLogin();
        return;
      }
      return original(() => Promise.resolve({
        default: resolvedModal
      }), attrs, stackModal);
    }
    if (isLogInModalClass(componentClass)) {
      redirectToOidcLogin();
      return;
    }
    return original(componentClass, attrs, stackModal);
  });
}
flarum.reg.add('dia-theme', 'forum/features/oidc-login/intercept-auth-intercept-auth-prompts', interceptAuthPrompts);